import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76ae7ef1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative inline-block border border-neutral-400 rounded-full" }
const _hoisted_2 = ["data-testid", "onClick"]

import { ref, watch } from 'vue'
import CalendarIcon from '@/assets/icons/calendar.vue'

interface DateRange {
  start: Date | null
  end: Date | null
}


export default /*#__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'DateFilter',
  props: {
    title: { default: 'Data' },
    isRange: { type: Boolean, default: true },
    modelValue: { default: null },
    dataTestid: { default: undefined }
  },
  emits: ["select", "opened"],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;







const datePicker = ref<any>(null)

const dateValue = ref<any>(props.modelValue ?? (props.isRange ? { start: null, end: null } : null))

watch(
  () => props.modelValue,
  (val) => {
    dateValue.value = val ?? (props.isRange ? { start: null, end: null } : null)
  }
)

function onSelectDate(val: any) {
  if (!val) return

  if (props.isRange) {
    if (val.start && val.end) {
      val.start.setHours(0, 0, 0, 0)
      val.end.setHours(23, 59, 59, 999)
      emit('select', { start: val.start, end: val.end })
      datePicker.value?.hidePopover()
    }
  } else {
    const start = new Date(val)
    start.setHours(0, 0, 0, 0)

    const end = new Date(val)
    end.setHours(23, 59, 59, 999)

    emit('select', { start, end })
    datePicker.value?.hidePopover()
  }
}

function close() {
  datePicker.value?.hidePopover()
}

// Sem isso, limpar o filtro de período pela tela deixa o intervalo preso no
// v-model interno do picker — e reselecionar o mesmo range não emite `select`.
// Mesmo contrato do ValueRangeFilter.reset().
function reset() {
  dateValue.value = props.isRange ? { start: null, end: null } : null
}

__expose({
  close,
  reset
})

return (_ctx: any,_cache: any) => {
  const _component_VDatePicker = _resolveComponent("VDatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VDatePicker, {
      ref_key: "datePicker",
      ref: datePicker,
      modelValue: dateValue.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((dateValue).value = $event)),
        onSelectDate
      ],
      "is-range": _ctx.isRange,
      onDidShow: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('opened')))
    }, {
      default: _withCtx(({ togglePopover }) => [
        _createElementVNode("button", {
          type: "button",
          "data-testid": _ctx.dataTestid,
          onClick: togglePopover,
          class: "flex items-center gap-2 px-4 py-2 rounded-full text-sm text-neutral-400 hover:bg-gray-100"
        }, [
          _createVNode(CalendarIcon, {
            width: 16,
            height: 16,
            color: "#7F7F7F"
          }),
          _createElementVNode("span", null, _toDisplayString(_ctx.title), 1)
        ], 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["modelValue", "is-range"])
  ]))
}
}

})